/**
 * Container Number Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {string}
 */
window.containerNumberFormatter = function(value, row) {
    let html;
    switch (row.container_type) {
        case "Reefer":
        case TYPE_REEFER:
            if (rights.includes("reefers.show")) {
                html = '<a href="/reefers/show/'+row.reefer_id+'">'+value+'</a>';
            } else {
                html = value;
            }
            break;
        case "Dry Container":
        case TYPE_DRY_CONTAINER:
            if (rights.includes("dry_containers.show")) {
                html = '<a href="/dry-containers/show/'+row.reefer_id+'">'+value+'</a>';
            } else {
                html = value;
            }
            break;
        default:
            html = value;
    }
    return html;
};
